// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";

import api from "./api"; // উপরে তৈরি করা file (src/api/index.js)

// অ্যাপ লোডে localStorage থেকে token ও school_id নিয়ে api.defaults সেট করে রাখি
try {
  const token = localStorage.getItem("token");
  if (token && token !== "null" && token !== "undefined") {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common["Authorization"];
  }

  const sid = localStorage.getItem("school_id");
  if (sid) {
    api.defaults.headers.common["X-School-Id"] = sid;
  } else {
    delete api.defaults.headers.common["X-School-Id"];
  }
} catch (e) {
  console.warn("[index] error setting api defaults:", e);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
